/* eslint-disable no-shadow */
export enum VehicleStatusEnum {
	active = 'active',
	inactive = 'inactive',
}

export const VehicleStatusValues = {
	[VehicleStatusEnum.active]: {
		title: 'Activo',
		color: 'green_300',
	},
	[VehicleStatusEnum.inactive]: {
		title: 'Inactivo',
		color: 'neutral_600',
	},
};
